import styled from 'styled-components';
import getThemeByProps from '@userzoomlibraries/toolkit-theme-manager/get-theme-by-props';
import React from 'react';
import LinkedFloatingElement from '@userzoomlibraries/toolkit-floating-element/linked-floating-element';
import { jsx } from 'react/jsx-runtime';

var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Tooltip$1 = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/jsx(LinkedFloatingElement, _objectSpread({
    ref: ref,
    className: "gz-tooltip ".concat(className),
    forceViewportPlacement: true
  }, props));
});
Tooltip$1.COMPONENT_ID = 'Gearz.Tooltip';
Tooltip$1.displayName = Tooltip$1.COMPONENT_ID;
Tooltip$1.ANIMATIONS = LinkedFloatingElement.ANIMATIONS;
Tooltip$1.PLACEMENTS = LinkedFloatingElement.PLACEMENTS;
Tooltip$1.TRIGGERS = LinkedFloatingElement.TRIGGERS;
Tooltip$1.propTypes = LinkedFloatingElement.propTypes;
Tooltip$1.defaultProps = _objectSpread(_objectSpread({}, LinkedFloatingElement.defaultProps), {}, {
  withArrow: true
});

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var Tooltip = styled(Tooltip$1).withConfig({
  componentId: "gz-tooltip-1673535319690__sc-i7fcw6-0"
})(["", ";"], function (props) {
  return getThemeByProps({
    componentId: Tooltip$1.COMPONENT_ID,
    props: props
  });
});
Tooltip.displayName = Tooltip$1.displayName;
Tooltip.propTypes = Tooltip$1.propTypes;
Tooltip.defaultProps = Tooltip$1.defaultProps;

export { Tooltip as T };
